import React from "react";
import {Paths} from "../app/components/sidebar/Paths";
import {H3SectionComponent} from "../app/components/section/SectionComponent";
import {GradientHeaderComponent} from "../app/components/gradientheader/GradientHeaderComponent";
import {ScreenComponent} from "../app/components/screen/ScreenComponent";

export default function PrivacyPolicyScreen() {
    return (<ScreenComponent>
        <Header/>
        <DataCollected/>
        <Compliance/>
        <Changes/>
        <ContactUs/>
    </ScreenComponent>);
}

function Header() {
    return (<GradientHeaderComponent title={Paths.privacy.name} tagline="Last Updated: November 23, 2024">
        <p>ShesAMobileDev.com ("ShesAMobileDev", "we", "us") is commited to protecting
            your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information
            when you use our website. By using our website, you agree to the terms of this Privacy Policy. If you do
            not agree, please discontinue using the website.</p>
    </GradientHeaderComponent>)
}

function DataCollected() {
    return (<H3SectionComponent header="Data Collected" tagline="What information we collect.">
        <ul>
            <li>Analytics: We use Google Analytics to gather anonymized data about your interaction with our
                website, such as pages visited, and links clicked. This data helps us improve your experience.
                Analytics data is retained for a maximum of 90 days. No Personally Identifiable Information (PII) is
                stored.
            </li>
            <li>Submitted Data: Any user-submitted data sent through forms or other means may be stored.</li>
            <li>Cookies: We use cookies to track your preferences and activity. Cookies help us personalize your
                experience. No Personally Identifiable Information (PII) is stored.
            </li>
            <li>External Links: Our website may contain links to third-party websites with different privacy
                practices. We are not responsible for the privacy policies or practices of those external websites.
                We encourage you to review their policies before engaging with them.
            </li>
        </ul>
    </H3SectionComponent>)
}

function Compliance() {
    return (<H3SectionComponent header="Compliance"
                                tagline="We comply with the following regulations to ensure your data is protected.">
        <ul>
            <li>General Data Protection Regulation (GDPR): No Personally Identifiable Information (PII) is stored.
            </li>
            <li>California Consumer Privacy Act (CCPA): No Personally Identifiable Information (PII) is stored, we
                do not see personal data.
            </li>
            <li>Children’s Online Privacy Protection Act (COPPA): Our website is not directed to children under 13
                years of age, and we do not knowingly collect personal information from children under 13.
            </li>
        </ul>
    </H3SectionComponent>)
}

function Changes() {
    return (<H3SectionComponent header="Changes to This Privacy Policy">
        <p>We may update this Privacy Policy from time-to-time to reflect changes in our practices or legal
            requirements. Updates will be posted on this page, and the effective date will be updated
            accordingly.</p>
    </H3SectionComponent>)
}

function ContactUs() {
    return (<H3SectionComponent header="Contact Us">
        <p>If you have questions or concerns about this Privacy Policy or our data practices, please email us at <a
            href="mailto: contactus@shesamobiledev.com">contactus@shesamobiledev.com</a>.</p>
    </H3SectionComponent>)
}
